import { paymentsApi } from '../httpService';


const getPayments = async (referenceId: any, query: any) => {
    /* try {
        const result = await paymentsApi.get(`/api/v1/customers/references/${referenceId}/transactions`, {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    } */
}


export default {
    getPayments
}